import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VirtualScrollService {
  public readonly itemsPerPage: number = 10;
  public pageNumber$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public loadMore$: Subject<void> = new Subject<void>();

  public resetPages(): void {
    this.pageNumber$.next(1)
  }

  public clearPages(): void {
    this.pageNumber$.next(0)
  }

  public increasePageNumber(): void {
    this.pageNumber$.next(this.pageNumber$.value + 1);
  }
}
